import * as z from 'zod';

export const StartCollectingRequestsRequest = z.object({
  appId: z
    .string()
    .describe(
      'ID of the app to start accepting notification requests for.\n\nBack in stock notifications only work for [Wix Stores](https://support.wix.com/en/article/wix-stores-about-wix-stores).\nThe `appId` for Wix Stores is `"215238eb-22a5-4c36-9e7b-e7c08025e04e"`.'
    )
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
});
export const StartCollectingRequestsResponse = z.object({
  settings: z
    .object({
      collectionStates: z
        .array(
          z.object({
            appId: z
              .string()
              .describe(
                'ID of the app to receive notification requests for.\n\nBack in stock notifications only work for [Wix Stores](https://support.wix.com/en/article/wix-stores-about-wix-stores).\nThe `appId` for Wix Stores is `"215238eb-22a5-4c36-9e7b-e7c08025e04e"`.'
              )
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional(),
            collectingRequests: z
              .boolean()
              .describe('Whether to collect requests for items from this app.')
              .optional(),
          })
        )
        .optional(),
    })
    .describe('Back in stock settings info.')
    .optional(),
});
export const StopCollectingRequestsRequest = z.object({
  appId: z
    .string()
    .describe(
      'ID of the app to stop accepting notification requests for.\n\nBack in stock notifications only work for [Wix Stores](https://support.wix.com/en/article/wix-stores-about-wix-stores).\nThe `appId` for Wix Stores is `"215238eb-22a5-4c36-9e7b-e7c08025e04e"`.'
    )
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
});
export const StopCollectingRequestsResponse = z.object({
  settings: z
    .object({
      collectionStates: z
        .array(
          z.object({
            appId: z
              .string()
              .describe(
                'ID of the app to receive notification requests for.\n\nBack in stock notifications only work for [Wix Stores](https://support.wix.com/en/article/wix-stores-about-wix-stores).\nThe `appId` for Wix Stores is `"215238eb-22a5-4c36-9e7b-e7c08025e04e"`.'
              )
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional(),
            collectingRequests: z
              .boolean()
              .describe('Whether to collect requests for items from this app.')
              .optional(),
          })
        )
        .optional(),
    })
    .describe('Back in stock settings info.')
    .optional(),
});
export const GetSettingsRequest = z.object({});
export const GetSettingsResponse = z.object({
  settings: z
    .object({
      collectionStates: z
        .array(
          z.object({
            appId: z
              .string()
              .describe(
                'ID of the app to receive notification requests for.\n\nBack in stock notifications only work for [Wix Stores](https://support.wix.com/en/article/wix-stores-about-wix-stores).\nThe `appId` for Wix Stores is `"215238eb-22a5-4c36-9e7b-e7c08025e04e"`.'
              )
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional(),
            collectingRequests: z
              .boolean()
              .describe('Whether to collect requests for items from this app.')
              .optional(),
          })
        )
        .optional(),
    })
    .describe('Retrieved back in stock request settings.')
    .optional(),
});
